import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCopy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1428_2544)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M13.375 10.9375C13.6211 10.9375 13.8125 10.7461 13.8125 10.5V5.11328C13.8125 4.97656 13.7578 4.86719 13.6758 4.78516L12.0898 3.19922C12.0078 3.11719 11.8984 3.0625 11.7891 3.0625H8.125C7.87891 3.0625 7.6875 3.25391 7.6875 3.5V10.5C7.6875 10.7461 7.87891 10.9375 8.125 10.9375H13.375ZM8.125 12.25C7.16797 12.25 6.375 11.457 6.375 10.5V3.5C6.375 2.54297 7.16797 1.75 8.125 1.75H11.7891C12.2539 1.75 12.6914 1.94141 13.0195 2.26953L14.6055 3.85547C14.9336 4.18359 15.125 4.64844 15.125 5.11328V10.5C15.125 11.457 14.332 12.25 13.375 12.25H8.125ZM4.625 5.25H5.0625V6.5625H4.625C4.37891 6.5625 4.1875 6.75391 4.1875 7V14C4.1875 14.2461 4.37891 14.4375 4.625 14.4375H9.875C10.1211 14.4375 10.3125 14.2461 10.3125 14V13.5625H11.625V14C11.625 14.957 10.832 15.75 9.875 15.75H4.625C3.66797 15.75 2.875 14.957 2.875 14V7C2.875 6.04297 3.66797 5.25 4.625 5.25Z",
			fill: "#868686"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1428_2544",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			fill: "white"
		})
	}) })]
});
export default SvgIconCopy;
